module.exports = __webpack_public_path__ + "img/pic-3.1e7f5fcc.png";